import type { HTMLAttributes } from "react";

import { cx } from "./cx";
import styles from "./skeleton.module.css";

export function Skeleton({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return <div className={cx(styles.skeleton, className)} {...props} />;
}
